import React, { useEffect } from "react";
import {  Container } from "reactstrap";
import { TableDrillDownCustom } from "./tableDrillDownCustom";
import config from "../../config";
import axios from "axios";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useCookies } from "react-cookie";

const MYO0001 = () => {
  document.title = "Defender | MyOrder";

  const { userProfile } = useSelector((state) => ({
    userProfile: state.login.user,
  }));

  const [cookies] = useCookies(["_csrf_token"]);
  const [revendaOptions, setRevendaOptions] = useState([])
  const [fornecedorOptions, setFornecedorOptions] = useState([])
  const [isLoading, setIsLoading] = useState(false)  

  const getDataRevenda = async () => {
    try {
      const { data } = await axios.post(
        `${config.URL_SERVER}/execute-procedure`,
        {
          proc: "FRONT_Usuario_Obter_Empresas_Origem_DecPerm",
          requestData: {
            1: userProfile?.resultset_2[0].ID_Usuario || 0,
            2: "PED",
          },
        },
        {
          headers: {
            "X-CSRF-Token": cookies._csrf_token?.data.csrfToken,
          },
        }
      );
      if (data.length) {
        const empresasOptions = data.map((item) => ({
          value: item.ID_Empresa,
          label: item.Nome_Empresa,
        }));
        setRevendaOptions(empresasOptions);
      }
    } catch (error) {
      console.log("Erro ao buscar dados [ComboboxRevenda] :", error);
    }
  };

  const getDataFornecedor = async () => {
    try {
      const { data } = await axios.post(
        `${config.URL_SERVER}/execute-procedure`,
        {
          proc: "FRONT_Usuario_Obter_Empresas_Destino_DecPerm",
          requestData: {
            1: userProfile?.resultset_2[0].ID_Usuario || 0,
            2: "PED",
          },
        },
        {
          headers: {
            "X-CSRF-Token": cookies._csrf_token?.data.csrfToken,
          },
        }
      );
      if (data.length) {
        const empresasOptions = data.map((item) => ({
          value: item.ID_Empresa,
          label: item.Nome_Empresa,
        }));
        setFornecedorOptions(empresasOptions);
      }
    } catch (error) {
      console.log("Erro ao buscar dados [ComboboxFornecedor] :", error);
    }
  };

  useEffect(() => {
      getDataRevenda();
      getDataFornecedor();
  }, []);
  
  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <Container fluid={true} className="dataTable-custom-primary">
          <TableDrillDownCustom
            dataKey="Codigo_Produto_Revenda"
            changeKeysReference={{
              "Codigo_Produto_Revenda": "Codigo_Produto_Revenda",
              "Ano": "Ano",
              "Mes_Descricao": "Mes",
              "Revenda": "ID_Empresa",
              "UF": "UF",
              "Descricao_Zona": "ID_Zona",
              "ID_Loja": "ID_Loja"
            }}
            customParams={{
              Codigo_Produto_Revenda: null,
              Ano: null,
              Mes: null,
              ID_Empresa: null,
              UF: null,
              ID_Zona: null,
              ID_Loja: null,
              ID_Empresa_Parceiro: null,
              ID_Planta: null,
              ID_Cidade: null,
            }}
            filterParams={{
              VisaoFilter: 'SKU',
              RevendaFilter: null,
              LojaFilter: null,
              FornecedorFilter: null,
              DataInicioFilter: new Date(new Date().setMonth(- 9)).toLocaleDateString(),
              DataFinalFilter: new Date().toLocaleDateString()
            }}
            hasLoading={isLoading}
            revendaOptions={revendaOptions}
            fornecedorOptions={fornecedorOptions}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MYO0001;
